import React, { useState } from 'react';
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Phone, Mail, Linkedin, Facebook, ChevronDown } from 'lucide-react';
// Declining headcount data showing workforce reduction starting in late 2025
const headcountData = [{
  date: 'Jan-10',
  count: 85
}, {
  date: 'Jul-10',
  count: 88
}, {
  date: 'Jan-11',
  count: 92
}, {
  date: 'Jul-11',
  count: 95
}, {
  date: 'Jan-12',
  count: 98
}, {
  date: 'Jul-12',
  count: 102
}, {
  date: 'Jan-13',
  count: 105
}, {
  date: 'Jul-13',
  count: 108
}, {
  date: 'Jan-14',
  count: 110
}, {
  date: 'Jul-14',
  count: 112
}, {
  date: 'Jan-15',
  count: 115
}, {
  date: 'Jul-15',
  count: 118
}, {
  date: 'Jan-16',
  count: 120
}, {
  date: 'Jul-16',
  count: 118
}, {
  date: 'Jan-17',
  count: 115
}, {
  date: 'Jul-17',
  count: 112
}, {
  date: 'Jan-18',
  count: 110
}, {
  date: 'Jul-18',
  count: 112
}, {
  date: 'Jan-19',
  count: 115
}, {
  date: 'Jul-19',
  count: 118
}, {
  date: 'Jan-20',
  count: 120
}, {
  date: 'Jul-20',
  count: 122
}, {
  date: 'Jan-21',
  count: 125
}, {
  date: 'Jul-21',
  count: 125
}, {
  date: 'Jan-22',
  count: 128
}, {
  date: 'Jul-22',
  count: 130
}, {
  date: 'Jan-23',
  count: 132
}, {
  date: 'Jul-23',
  count: 135
}, {
  date: 'Jan-24',
  count: 138
}, {
  date: 'Jul-24',
  count: 140
}, {
  date: 'Jan-25',
  count: 142
}, {
  date: 'Apr-25',
  count: 142
}, {
  date: 'Jul-25',
  count: 140
}, {
  date: 'Oct-25',
  count: 125
}, {
  date: 'Dec-25',
  count: 95
}, {
  date: 'Feb-26',
  count: 75
}, {
  date: 'Mar-26',
  count: 75
}];
// Declining role data
const roleData = [{
  date: 'Jan-18',
  Sales: 25,
  Operations: 15,
  Accounting: 8,
  HR: 5,
  Engineering: 30,
  CS: 12,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-18',
  Sales: 24,
  Operations: 14,
  Accounting: 8,
  HR: 5,
  Engineering: 28,
  CS: 11,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-19',
  Sales: 23,
  Operations: 14,
  Accounting: 7,
  HR: 5,
  Engineering: 26,
  CS: 10,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-19',
  Sales: 22,
  Operations: 13,
  Accounting: 7,
  HR: 4,
  Engineering: 24,
  CS: 10,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-20',
  Sales: 20,
  Operations: 12,
  Accounting: 7,
  HR: 4,
  Engineering: 22,
  CS: 10,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-20',
  Sales: 18,
  Operations: 12,
  Accounting: 6,
  HR: 4,
  Engineering: 20,
  CS: 10,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-21',
  Sales: 17,
  Operations: 11,
  Accounting: 6,
  HR: 4,
  Engineering: 18,
  CS: 9,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-21',
  Sales: 16,
  Operations: 10,
  Accounting: 6,
  HR: 3,
  Engineering: 16,
  CS: 9,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-22',
  Sales: 15,
  Operations: 10,
  Accounting: 5,
  HR: 3,
  Engineering: 14,
  CS: 8,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-22',
  Sales: 14,
  Operations: 9,
  Accounting: 5,
  HR: 3,
  Engineering: 12,
  CS: 7,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-23',
  Sales: 13,
  Operations: 8,
  Accounting: 5,
  HR: 3,
  Engineering: 10,
  CS: 6,
  Management: 10,
  IT: 0
}, {
  date: 'Jul-23',
  Sales: 12,
  Operations: 7,
  Accounting: 4,
  HR: 2,
  Engineering: 9,
  CS: 6,
  Management: 10,
  IT: 0
}, {
  date: 'Jan-24',
  Sales: 11,
  Operations: 7,
  Accounting: 4,
  HR: 2,
  Engineering: 8,
  CS: 5,
  Management: 8,
  IT: 0
}, {
  date: 'Jul-24',
  Sales: 10,
  Operations: 6,
  Accounting: 4,
  HR: 2,
  Engineering: 7,
  CS: 5,
  Management: 6,
  IT: 0
}, {
  date: 'Jan-25',
  Sales: 9,
  Operations: 5,
  Accounting: 3,
  HR: 2,
  Engineering: 6,
  CS: 4,
  Management: 6,
  IT: 0
}, {
  date: 'Jul-25',
  Sales: 8,
  Operations: 5,
  Accounting: 3,
  HR: 1,
  Engineering: 5,
  CS: 3,
  Management: 5,
  IT: 0
}];
const departments = [{
  key: 'Sales',
  color: '#4f46e5',
  label: 'Sales'
}, {
  key: 'Operations',
  color: '#0ea5e9',
  label: 'Operations'
}, {
  key: 'Accounting',
  color: '#10b981',
  label: 'Accounting'
}, {
  key: 'HR',
  color: '#f59e0b',
  label: 'Human Resources'
}, {
  key: 'Engineering',
  color: '#8b5cf6',
  label: 'Engineering'
}, {
  key: 'CS',
  color: '#ec4899',
  label: 'Customer Service'
}, {
  key: 'Management',
  color: '#ef4444',
  label: 'Management'
}, {
  key: 'IT',
  color: '#64748b',
  label: 'IT'
}];
const principals = [{
  name: 'Bill Lumbergh',
  role: 'VP Operations',
  phone: '(512) 555-0200',
  email: 'b.lumbergh@initech.com',
  status: 'Current',
  previous: ['Penetrode (1995-2010)'],
  socials: ['linkedin'],
  linkedin: 'https://www.linkedin.com/in/bill-lumbergh/'
}, {
  name: 'Dom Portwood',
  role: 'Senior VP',
  phone: '(512) 555-0201',
  email: 'd.portwood@initech.com',
  status: 'Current',
  previous: [],
  socials: ['linkedin'],
  linkedin: '#'
}, {
  name: 'Nina McInroe',
  role: 'VP Human Resources',
  phone: '(512) 555-0202',
  email: 'n.mcinroe@initech.com',
  status: 'Current',
  previous: [],
  socials: [],
  linkedin: '#'
}];
export function InitechPeopleTab() {
  const [activeDepartments, setActiveDepartments] = useState<string[]>(departments.map(d => d.key));
  const toggleDepartment = (key: string) => {
    if (activeDepartments.includes(key)) {
      setActiveDepartments(activeDepartments.filter(d => d !== key));
    } else {
      setActiveDepartments([...activeDepartments, key]);
    }
  };
  const toggleAll = () => {
    if (activeDepartments.length === departments.length) {
      setActiveDepartments([]);
    } else {
      setActiveDepartments(departments.map(d => d.key));
    }
  };
  return <div className="space-y-6 mt-6" data-id="element-2572">
      {/* Employee Headcount Chart */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-2573">
        <div className="flex justify-between items-start mb-6" data-id="element-2574">
          <div data-id="element-2575">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-2576">
              Employee Headcount
            </h2>
            <div className="inline-block border-b-2 border-red-600 pb-1 mb-1" data-id="element-2577">
              <span className="text-xl font-bold text-red-600" data-id="element-2578">-47%</span>
            </div>
            <p className="text-sm text-gray-600" data-id="element-2579">12 Month Growth Rate</p>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-2580">
            ALL <ChevronDown className="w-4 h-4" data-id="element-2581" />
          </button>
        </div>
        <div className="h-72 w-full" data-id="element-2582">
          <ResponsiveContainer width="100%" height="100%" data-id="element-2583">
            <LineChart data={headcountData} margin={{
            top: 5,
            right: 0,
            left: -20,
            bottom: 0
          }} data-id="element-2584">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2585" />
              <XAxis dataKey="date" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} minTickGap={30} data-id="element-2586" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 140]} ticks={[0, 35, 70, 105, 140]} data-id="element-2587" />
              <Tooltip contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
            }} data-id="element-2588" />
              <Line type="monotone" dataKey="count" stroke="#000000" strokeWidth={2} dot={false} activeDot={{
              r: 6,
              fill: '#000000'
            }} data-id="element-2589" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Company Principals Table */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2590">
        <div className="p-6 border-b border-gray-200" data-id="element-2591">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-2592">
            Company Principals
          </h2>
        </div>
        <div className="overflow-x-auto" data-id="element-2593">
          <table className="w-full text-left border-collapse" data-id="element-2594">
            <thead data-id="element-2595">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-2596">
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2597">
                  Name
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2598">
                  Role
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2599">
                  Phone/Email
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2600">
                  Status
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-2601">
                  Previous Employers
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 text-right" data-id="element-2602">
                  Socials
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2603">
              {principals.map((principal, idx) => <tr key={idx} className="hover:bg-gray-50/50" data-id="element-2604">
                  <td className="px-6 py-4" data-id="element-2605">
                    <span className="font-bold text-gray-900" data-id="element-2606">
                      {principal.name}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600" data-id="element-2607">
                    {principal.role}
                  </td>
                  <td className="px-6 py-4" data-id="element-2608">
                    <div className="space-y-1" data-id="element-2609">
                      <div className="flex items-center gap-2 text-sm" data-id="element-2610">
                        <Phone className="w-4 h-4 text-gray-400" data-id="element-2611" />
                        <a href={`tel:${principal.phone}`} className="text-indigo-600 hover:underline" data-id="element-2612">
                          {principal.phone}
                        </a>
                      </div>
                      <div className="flex items-center gap-2 text-sm" data-id="element-2613">
                        <Mail className="w-4 h-4 text-gray-400" data-id="element-2614" />
                        <a href={`mailto:${principal.email}`} className="text-indigo-600 hover:underline" data-id="element-2615">
                          {principal.email}
                        </a>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-2616">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${principal.status === 'Current' ? 'bg-gray-100 text-gray-800 border border-gray-200' : 'bg-red-100 text-red-700 border border-red-200'}`} data-id="element-2617">
                      {principal.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2618">
                    {principal.previous.length > 0 ? <ul className="list-disc list-inside text-sm text-gray-600 space-y-0.5" data-id="element-2619">
                        {principal.previous.map((prev, i) => <li key={i} data-id="element-2620">{prev}</li>)}
                      </ul> : <span className="text-sm text-gray-400" data-id="element-2621">-</span>}
                  </td>
                  <td className="px-6 py-4" data-id="element-2622">
                    <div className="flex items-center justify-end gap-2" data-id="element-2623">
                      {principal.socials.includes('linkedin') && <a href={principal.linkedin} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#0077b5] flex items-center justify-center text-white hover:opacity-90 transition-opacity" data-id="element-2624">
                          <Linkedin className="w-4 h-4" data-id="element-2625" />
                        </a>}
                      {principal.socials.includes('facebook') && <a href="#" className="w-8 h-8 rounded-full bg-[#1877f2] flex items-center justify-center text-white hover:opacity-90 transition-opacity" data-id="element-2626">
                          <Facebook className="w-4 h-4" data-id="element-2627" />
                        </a>}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}